module.exports = __webpack_public_path__ + "onboarding-cowboy.d6851545bcee5a8dd233c86c4b5caad1.hashedasset.svg";